// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

// import CaretDown from "@guestsupply/XDL/Icons/CaretDown";
// import CaretUp from "@guestsupply/XDL/Icons/CaretUp";
import CaretDown from "@guestsupply/XDL/Icons/CaretDown";
import CaretUp from "@guestsupply/XDL/Icons/CaretUp";
import { xBaseTheme } from "@guestsupply/XDL/types";
import { color } from "@guestsupply/XDL/Utilities";
import { AccordionSectionPanel } from "@insite/mobius/AccordionSection";
import { AccordionSectionHeaderProps } from "@insite/mobius/AccordionSection/AccordionSectionHeader";
import AccordionSectionPresentationPropsDefault from "@insite/mobius/AccordionSection/presentationProps";
import { css } from "styled-components";

export default {
    defaultProps: {
        mergeCss: true,
    },
    sectionDefaultProps: {
        ...AccordionSectionPresentationPropsDefault,
        mergeCss: true,
        collapseIconProps: {
            src: CaretUp,
            size: 10,
            color: "primary.main",
        },
        expandIconProps: {
            src: CaretDown,
            size: 10,
            color: "primary.main",
        },
        titleTypographyProps: {
            size: 12,
            weight: 500,
            css: css`
                letter-spacing: 0;
                line-height: 13px;
            `,
        },
        panelProps: {
            css: css`
                border: none;
                padding: 8px;
                margin-top: -12px;
                margin-bottom: 12px;
            `,
        },
        headerProps: {
            css: css`
                button,
                button:focus {
                    padding: 8px;
                    border-bottom: none;
                    border-left: none;
                    border-right: none;
                    background: ${color("common.ui1")};
                    border-top: 1px solid ${color("common.border")} !important;
                }
            `,
        },
        toggleIconProps: {
            size: 10,
        },
    },
} as xBaseTheme["accordion"];
